import { ChangeDetectionStrategy, Component, computed, signal } from '@angular/core';
import { MatMenuModule } from '@angular/material/menu';
import { FaIconComponent } from '@fortawesome/angular-fontawesome';
import { faCaretDown } from '@fortawesome/free-solid-svg-icons';
import { select } from '@ngxs/store';
import { CompanyDTO } from '../../../../../../common/dto/company.dto';
import { AppState } from '../../../app.state';
import { LoadingIndicatorComponent } from '../../../common/components/loading-indicator/loading-indicator.component';
import { AuthenticationService } from '../../../common/services/authentications.service';
import { CompaniesService } from '../../../common/services/companies.service';

@Component({
  selector: 'app-company-switcher',
  imports: [
    MatMenuModule,
    LoadingIndicatorComponent,
    FaIconComponent,
  ],
  templateUrl: './company-switcher.component.html',
  styleUrl: './company-switcher.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CompanySwitcherComponent {
  constructor(
    private _authenticationService: AuthenticationService,
    private _companies: CompaniesService,
  ) {
  }

  protected appState = select(AppState.get);

  protected hasMultipleCompanyAccess = computed(() => (this.appState()?.session?.companies.length ?? 0) > 1);

  protected availableCompanies = signal<CompanyDTO[] | undefined>(undefined);

  protected async onSwitcherOpenedAsync() {
    if (this.availableCompanies()) {
      return;
    }

    this.availableCompanies.set(await this._companies.getAvailableCompaniesAsync());
  }

  protected async switchCompanyAsync(company: CompanyDTO) {
    await this._authenticationService.switchCompanyAsync(company.id);
  }

  protected readonly faCaretDown = faCaretDown;
}
